"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrationService = void 0;
const semver_1 = require("semver");
const echain_shared_logging_1 = require("@igus/echain-shared-logging");
/**
 * The `MigrationService` provides methods to perform migrations.
 */
class MigrationService {
    /**
     * Checks whether a migration is required. If it is required, it will trigger the migration
     * process.
     * It will clone the given data before migration to guarantee that the original data is not
     * touched.
     *
     * @param data The data to check and process migration for.
     * @param migrations The versioned migrations functions used for processing the migrations.
     * @returns A clone of the checked and optionally migrated data.
     */
    static process(data, migrations) {
        // clone the original data
        let dataClone;
        try {
            dataClone = JSON.parse(JSON.stringify(data));
        }
        catch (e) {
            throw new Error('MigrationService.process: Error while cloning data');
        }
        // set a default domainVersion
        if (dataClone.DomainVersion == null) {
            dataClone.DomainVersion = '0.0.1';
        }
        // check that domainVersion is valid
        if (dataClone.DomainVersion === '0') {
            (0, echain_shared_logging_1.getLogger)().warn('MigrationService.process: Using domainVersion 0');
            return { json: dataClone };
        }
        if (!(0, semver_1.valid)(dataClone.DomainVersion) && dataClone.DomainVersion !== '0') {
            throw new echain_shared_logging_1.SentryError('MigrationService.process: Invalid domainVersion in data', {
                DomainVersion: dataClone.DomainVersion,
            });
        }
        // migrate
        const migratedData = this.migrate(dataClone, migrations);
        return { json: migratedData };
    }
    /**
     * Processes the migration with the given migration functions on a given data object.
     *
     * @param data The data to check and process migration for.
     * @param migrations The versioned migrations functions used for processing the migrations.
     * @returns The migrated data.
     */
    static migrate(data, migrations) {
        let i = this.getFirstMigrationIndex(data, migrations);
        if (i <= -1)
            return data;
        const l = migrations.length;
        for (; i < l; i++) {
            const { migrate, version } = migrations[i];
            data = migrate(data);
            data.DomainVersion = version;
        }
        return data;
    }
    /**
     * Retrieves the array-index of the first migration required to be performed.
     *
     * @param data The data to check and process migration for.
     * @param migrations The versioned migrations functions used for processing the migrations.
     * @returns The array index of the migrations array.
     */
    static getFirstMigrationIndex(data, migrations) {
        const dataDomainVersion = data.DomainVersion;
        if (!dataDomainVersion) {
            throw new Error(`MigrationService.getFirstMigrationIndex: data.DomainVersion is invalid`);
        }
        return migrations.findIndex(({ version }) => (0, semver_1.gt)(version, dataDomainVersion));
    }
}
exports.MigrationService = MigrationService;
//# sourceMappingURL=MigrationService.js.map